import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from "./router/app";
import './assets/styles/app.scss';
import {HelmetProvider} from "react-helmet-async";
import {AuthProvider} from "./context/auth";
import MessageProvider from "./context/message";
import GlobalNotificationMessage from "./components/global-notification-message";
import {StripeProvider} from "./context/stripe";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AuthProvider>
            <HelmetProvider>
                <MessageProvider>
                    <StripeProvider>
                        <GlobalNotificationMessage />
                        <App />
                    </StripeProvider>
                </MessageProvider>
            </HelmetProvider>
        </AuthProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
